import { forwardRef } from 'react';
import { observer } from 'mobx-react';
import { useRootStore } from '@nandosaus/state-management';
import { HeadingWithFlameHighlights } from '@components/heading-with-flame-highlights';
import { Flex } from '../../grid';
import { StylePicker } from '../../style-picker';

const RemoveIngredientsScreen = forwardRef((props, ref) => {
  const { ProductDetailsState } = useRootStore();
  const choice = ProductDetailsState.product.removeChoice;

  return (
    <Flex
      ref={ref}
      flexDirection="column"
      gap="16px"
      borderTop="4px solid warmWhite3"
      borderBottom="4px solid warmWhite3"
      marginTop="16px"
      paddingTop="16px"
      paddingBottom="16px"
    >
      <Flex justifyContent="left">
        <HeadingWithFlameHighlights heading="Remove Items" mb="0" variant="section" />
      </Flex>
      <StylePicker
        px="0"
        id={choice.id}
        title={choice.name}
        type={choice.type}
        required={choice.required}
        items={choice.optionsForPicker.map(option => ({
          ...option,
          image: undefined,
        }))}
        selectedItems={ProductDetailsState.optionIdsForChoiceName(choice.name)}
        onSelect={selectedValues => {
          const updatedValues = selectedValues.map(item => {
            const id = item.value;
            const value = choice.optionById(id);
            return value;
          });
          ProductDetailsState.updateChoice(choice.name, updatedValues);
        }}
        showClearFilter={choice.hasDisabledOptions}
        showTitle={false}
        borderRadius="4px"
      />
    </Flex>
  );
});

const ComposedRemoveIngredientsScreen = observer(RemoveIngredientsScreen);
export { ComposedRemoveIngredientsScreen as RemoveIngredientsScreen };
